module.exports = __webpack_public_path__ + "static/media/30.8085d750.jpg";